module.exports = __webpack_public_path__ + "static/mobileHero-c69f243687acf8b882bfc0f6fa9412da.png";